export default __webpack_public_path__ + "40b2d93bf7c7bc806b711c69f238235b.png";